import { Injectable, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { UtilsService } from './utils.service';
import { ConstantsService } from '../services/constants.service'
import { Observable, of, timer } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FlashService {

    sucessPopupTemplate: string = "ng1/src/common/sucessPopup.html";
    errorPopupTemplate: string = "ng1/src/common/errorPopup.html";
    alertPopupTemplate: string = "ng1/src/common/alertPopup.html";
    loadingTemplate: string = "ng1/src/common/preLoaderPopup.html";
    progressBar: any = { value: 0, show: false };
    private timeInterval;
    private timerPeriodLength: number = 100;


    constructor(@Inject('$rootScope') private $rootScope: angular.IRootScopeService & { [name: string]: any }, private location: Location, private Utils: UtilsService, private constants: ConstantsService) { }

    private clearFlashMessage() {
        var flash = this.$rootScope.flash;
        if (flash) {
            if (!flash.keepAfterLocationChange) {
                delete this.$rootScope.flash;
            } else {
                // only keep for a single location change
                flash.keepAfterLocationChange = false;
            }
        }
    }

    ngOnInit() {
        var self = this;
        this.$rootScope.$on('$locationChangeStart', function () {
            self.clearFlashMessage();
        });
    }

    Success(message) {
        var modal = this.Utils.OpenModal(message, this.sucessPopupTemplate, null, null, 'general-success-popup', null, null);
            setTimeout(function () {
                modal.dismiss();
            }, 2000);
    }

    Error(message, withCloseBtn) {
        this.Utils.OpenModal(message,
            this.errorPopupTemplate,
            null,
            {
                withCloseBtn: withCloseBtn
            }, null, null, null);
    }

    Alert(message, title, onOkAction) {
        onOkAction = onOkAction ? onOkAction : 'dismissAndRedirectBack';

        this.Utils.OpenModal(message,
            this.alertPopupTemplate,
            null,
            {
                title: title,
                action: onOkAction
            }, null, null, null);
    }

    Loading() {
        return this.Utils.OpenModal('', this.loadingTemplate, null, null, 'preloader', null, true);
    }

    Clear() {
        this.$rootScope.flash = null;
    }

    ShowProgressBar(loadingSpeed?: number) {
        let progressBarSpeed: string;
        switch (loadingSpeed) {
            case this.constants.ProgressBarLoadingSpeed.Quick:
                progressBarSpeed = 'fast';
                break;
            case this.constants.ProgressBarLoadingSpeed.Slow:
                progressBarSpeed = 'slow';
                break;
            default:
                progressBarSpeed = 'medium';
        }

        this.$rootScope.$broadcast('startProgressBar', progressBarSpeed);
    }

    HideProgressBar() {
        this.$rootScope.$broadcast('completeProgessBar');
    }

}